"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;

var PropTypes = __importStar(require("prop-types"));

var React = __importStar(require("react"));

var rxjs_1 = require("rxjs");

var createUiVisibilityObservable_1 = __importDefault(require("../utils/createUiVisibilityObservable"));

var loadOrPlayOrPause_1 = __importDefault(require("../utils/loadOrPlayOrPause"));

var FullscreenButton_1 = __importDefault(require("./FullscreenButton"));

var PlayPauseButton_1 = __importDefault(require("./PlayPauseButton"));

var TimeIndicator_1 = __importDefault(require("./TimeIndicator"));

var Timeline_1 = __importDefault(require("./Timeline"));

var UiContainer_1 = __importDefault(require("./UiContainer"));

var VolumeControl_1 = __importDefault(require("./VolumeControl"));

var FullUi =
/** @class */
function (_super) {
  __extends(FullUi, _super);

  function FullUi(props) {
    var _this = _super.call(this, props) || this;

    _this._onPointerOrMouseDown = function (e) {
      if (e.defaultPrevented) {
        return;
      } // Return early if click is on bottom container


      if (_this.bottomContainer && (e.target === _this.bottomContainer || _this.bottomContainer && _this.bottomContainer.contains(e.target))) {
        return;
      } // Return early if event is touch/tap


      var isTouch = typeof PointerEvent !== 'undefined' && e instanceof PointerEvent ? e.pointerType !== 'mouse' : _this.props.isTouch;

      if (isTouch) {
        return;
      }

      if (_this.props.controller) {
        loadOrPlayOrPause_1["default"](_this.props.controller, _this.props.playerState, _this.props.streamInfo, {
          autoPlay: true
        }, _this.props.setPlayQueued);
      }
    };

    _this.containerElement = null;
    _this.bottomContainer = null;
    _this.subscription = null;
    _this.playerState$ = new rxjs_1.Subject();
    _this.stateVisible$ = new rxjs_1.Subject();
    _this.uiPosition$ = new rxjs_1.Subject();
    _this.loop$ = new rxjs_1.Subject();
    _this.state = {
      visible: false,
      dimmedTimeline: false
    };
    return _this;
  }

  FullUi.prototype.componentDidMount = function () {
    var _this = this;

    if (this.containerElement && this.bottomContainer) {
      this.subscription = createUiVisibilityObservable_1["default"](this.containerElement, this.bottomContainer, this.playerState$, this.stateVisible$, this.uiPosition$, this.loop$).subscribe(function (visible) {
        _this.setState({
          visible: visible
        });
      });

      if (typeof window.onpointerdown !== 'undefined') {
        /*
            onPointerDown is added as a synthetic event in React 16.4
         */
        this.containerElement.addEventListener('pointerdown', this._onPointerOrMouseDown);
      } else {
        // Fallback when pointer events are not available
        this.containerElement.addEventListener('mousedown', this._onPointerOrMouseDown);
      }
    }

    this.playerState$.next(this.props.playerState);
    this.stateVisible$.next(this.state.visible);
    this.uiPosition$.next(this.props.uiPosition);
    this.loop$.next(this.props.loop);
  };

  FullUi.prototype.componentDidUpdate = function () {
    this.playerState$.next(this.props.playerState);
    this.stateVisible$.next(this.state.visible);
    this.uiPosition$.next(this.props.uiPosition);
    this.loop$.next(this.props.loop);
  };

  FullUi.prototype.componentWillUnmount = function () {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }

    if (this.containerElement) {
      this.containerElement.removeEventListener('pointerdown', this._onPointerOrMouseDown);
      this.containerElement.removeEventListener('mousedown', this._onPointerOrMouseDown);
    }
  };

  FullUi.prototype.render = function () {
    var _this = this;

    return React.createElement(UiContainer_1["default"], {
      visible: this.state.visible,
      innerRef: function innerRef(ref) {
        return _this.containerElement = ref;
      }
    }, React.createElement(UiContainer_1["default"].Bottom, {
      innerRef: function innerRef(ref) {
        return _this.bottomContainer = ref;
      }
    }, React.createElement(UiContainer_1["default"].Top, null, React.createElement(Timeline_1["default"], {
      controller: this.props.controller,
      playerState: this.props.playerState,
      position: this.props.position,
      duration: this.props.duration,
      dimmed: this.state.dimmedTimeline,
      uiPosition: this.props.uiPosition,
      streamInfo: this.props.streamInfo
    })), React.createElement(UiContainer_1["default"].Left, null, React.createElement(PlayPauseButton_1["default"], {
      controller: this.props.controller,
      playerState: this.props.playerState,
      streamInfo: this.props.streamInfo,
      duration: this.props.duration,
      setPlayQueued: this.props.setPlayQueued
    }), React.createElement(TimeIndicator_1["default"], {
      "aria-hidden": "true",
      position: this.props.position,
      duration: this.props.duration,
      uiPosition: this.props.uiPosition
    })), React.createElement(UiContainer_1["default"].Right, null, React.createElement(VolumeControl_1["default"], {
      controller: this.props.controller,
      value: this.props.volume,
      muted: this.props.muted,
      onActiveChange: function onActiveChange(active) {
        return _this.setState({
          dimmedTimeline: active
        });
      }
    }), React.createElement(FullscreenButton_1["default"], {
      getFullscreenElement: this.props.getFullscreenElement
    }))));
  };

  FullUi.contextTypes = {
    theme: PropTypes.object
  };
  return FullUi;
}(React.Component);

exports["default"] = FullUi;